import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "@/hooks/useAuth";
import Index from "./pages/Index";
import Auth from "./pages/Auth";
import Admin from "./pages/Admin";
import BlogPost from "./pages/BlogPost";
import Aktuelt from "./pages/Aktuelt";
import BunadDetail from "./pages/BunadDetail";
import Tilbehor from "./pages/Tilbehor";
import Sporsmal from "./pages/Sporsmal";
import Sok from "./pages/Sok";
import Personvern from "./pages/Personvern";
import NotFound from "./pages/NotFound";


const queryClient = new QueryClient();

const App = () => (
  <QueryClientProvider client={queryClient}>
    <TooltipProvider>
      <AuthProvider>
        <Toaster />
        <Sonner />
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Index />} />
            <Route path="/auth" element={<Auth />} />
            <Route path="/admin" element={<Admin />} />
            <Route path="/blogg/:id" element={<BlogPost />} />
            <Route path="/aktuelt" element={<Aktuelt />} />
            <Route path="/drakt/:id" element={<BunadDetail />} />
            <Route path="/tilbehor" element={<Tilbehor />} />
            <Route path="/sporsmal" element={<Sporsmal />} />
            <Route path="/sok" element={<Sok />} />
            <Route path="/personvern" element={<Personvern />} />
            {/* ADD ALL CUSTOM ROUTES ABOVE THE CATCH-ALL "*" ROUTE */}
            <Route path="*" element={<NotFound />} />
          </Routes>
          
        </BrowserRouter>
      </AuthProvider>
    </TooltipProvider>
  </QueryClientProvider>
);

export default App;
